interface Config {
  API_URL: string;
  WS_URL: string;
}

// Determine if we're in development mode
const isDev = import.meta.env.DEV;
const isUAT = (import.meta.env.VITE_IS_UAT || '').toLowerCase() === 'true';

// Get the current origin (protocol + host) for production use
const getCurrentOrigin = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

// Get the API URL based on the current hostname
const getApiUrl = () => {
  if (isDev) {
    return isUAT ? (import.meta.env.VITE_API_URL || 'http://localhost:3000') : 'http://localhost:3000';
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Extract domain parts
    const parts = hostname.split('.');
    
    // If we're on a subdomain (tenant.flowcxp.com)
    if (parts.length > 2 && parts[0] !== 'www' && parts[0] !== 'api') {
      // Use api.flowcxp.com as the API endpoint for all tenants
      return `https://api.${parts.slice(-2).join('.')}`;
    }
    
    // Default to api.flowcxp.com
    return 'https://api.flowcxp.com';
  }
  
  return 'https://api.flowcxp.com';
};

// Get the WebSocket URL based on the current hostname
const getWsUrl = () => {
  if (isDev) {
    return isUAT ? 'wss://api.uat-flowcxp.com' : 'ws://localhost:3000';
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Extract domain parts
    const parts = hostname.split('.');
    
    // If we're on a subdomain (tenant.flowcxp.com)
    if (parts.length > 2 && parts[0] !== 'www' && parts[0] !== 'api') {
      // Use wss://api.flowcxp.com as the WebSocket endpoint for all tenants
      return `wss://api.${parts.slice(-2).join('.')}`;
    }
    
    // Default to wss://api.flowcxp.com
    return 'wss://api.flowcxp.com';
  }
  
  return 'wss://api.flowcxp.com';
};

// Configure API and WebSocket URLs based on environment
const config: Config = {
  // Use the production API URL or environment variable if set
  API_URL: isUAT ? (import.meta.env.VITE_API_URL || 'http://13.212.92.46:3000') : (window.location.protocol === 'https:' ? 'https://api.flowcxp.com' : getApiUrl()),
  
  // WebSocket URL or environment variable if set
  WS_URL: isUAT ? 'wss://api.uat-flowcxp.com' : (window.location.protocol === 'https:' ? 'wss://api.flowcxp.com' : getWsUrl())
};

// Log the configuration in development
if (import.meta.env.DEV) {
  console.log('API URL:', config.API_URL);
  console.log('WebSocket URL:', config.WS_URL);
}

export default config;

// For backward compatibility
export const API_BASE_URL = config.API_URL;